'use client';

import { useParams, useRouter } from 'next/navigation';
import { useEffect } from 'react';

export const Replace = () => {
  const { paymentLinkId } = useParams<{ paymentLinkId: string }>();
  const { replace } = useRouter();

  useEffect(() => {
    replace(`/${paymentLinkId}`);
  }, []);

  return null;
};
